import React, { useEffect, useState } from "react";
import NavBar from "../NavBar/NavBar";
import "./Cart.css";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusCircle } from "@fortawesome/free-solid-svg-icons";
import StripePayment from "../../StripePayment/StripePayment";
import swal from "sweetalert";

const Cart = () => {
  const [cartProducts, setCardProducts] = useState([]);
  const token = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    axios
      .get("https://mysterious-sierra-48850.herokuapp.com/get-cart", {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token.token,
        },
      })
      .then((data) => {
        setCardProducts(data.data);
      })
      .catch((err) => console.log(err.response));
  }, []);

  const totalPrice =
    cartProducts.length &&
    cartProducts.map((pd) => pd.price).reduce((p = 0, c = 0) => +p + +c);

  const checkOutHandler = (paymentId) => {
    console.log(paymentId);

    const products = cartProducts.map((pd) => {
      delete pd.image;
      delete pd._id;
      return pd;
    });
    const productsForSubmit = { products, totalPrice, paymentId };
    axios
      .post("https://mysterious-sierra-48850.herokuapp.com/submit-order", productsForSubmit, {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token.token,
        },
      })
      .then((data) => {
        console.log(data.data);
        if (data?.data?.success) {
          swal("Good job!", `${data?.data?.message}`, "success");
          clearOnSubmitCartHandler()
        } else {
          swal(
            "Error Boss!",
            `${data?.data?.message} || something went wrong`,
            "success"
          );
        }
      })
      .catch((err) => console.log(err.response));
  };

  const clearOnSubmitCartHandler = () => {
    axios
      .delete("https://mysterious-sierra-48850.herokuapp.com/clear-cart", {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token.token,
        },
      })
      .then((data) => {
        // console.log(data)
      })
      .catch((err) => console.log(err));
  };

  const [isPayment, setIsPayment] = useState(null);

  return (
    <>
      {isPayment === null ? (
        <>
          <NavBar cartProducts={cartProducts} />
          <Container style={{ marginTop: "100px" }}>
            {cartProducts.length === 0 && (
              <h1 className="text-center">Loading...</h1>
            )}
            <Row>
              <Col>
                {cartProducts.map((pd) => {
                  return (
                    <Card className="m-2" style={{ maxWidth: "320px" }}>
                      <Card.Title>
                        <div className="d-flex justify-content-between">
                          {pd?.name}
                          <FontAwesomeIcon
                            icon={faMinusCircle}
                            style={{ cursor: "pointer" }}
                          />
                        </div>
                      </Card.Title>
                      <Card.Body>
                        <div className="d-flex">
                          <img
                            className="align-self-center mr-3 avatar"
                            style={{ objectFit: "cover" }}
                            src={`data:image/png;base64,${pd?.image?.data}`}
                            alt="img"
                          />
                          <div>
                            <Card.Text>{pd?.description}</Card.Text>
                            <Card.Text>&#2547;{pd?.price}</Card.Text>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  );
                })}
              </Col>
              <Col>
                <Card className="m-2">
                  <Card.Title>Orders</Card.Title>
                  <Card.Body>
                    <Card.Text>Total: ${totalPrice}</Card.Text>
                    <Button onClick={() => setIsPayment(true)}>
                      Check Out Now
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
      ) : (
        <div style={{ marginTop: "100px" }}>
          <StripePayment
            checkOutHandler={checkOutHandler}
            setIsPayment={setIsPayment}
            totalPrice={totalPrice}
          />
        </div>
      )}
    </>
  );
};

export default Cart;
